var map = {
	"./falando.png": 9247,
	"./falando2.png": 4925,
	"./falando_feliz.png": 7350,
	"./falando_feliz2.png": 2566,
	"./feliz.png": 8988,
	"./normal.png": 4215,
	"./sorriso.png": 5905,
	"./sorriso2.png": 4551,
	"./triste.png": 7405
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4983;